import { getPortalSdk } from 'portal-sdk';
import { UseQueryOptions, useQuery } from 'react-query';

import { VoiceboxSettings } from 'bones/constants/voicebox/settings';
import { usePortalConnectionByIndex } from 'bones/utils/portal/usePortalConnectionByIndex';

export const usePortalVoiceboxLastSettings = (
  connectionIdx: number,
  options?: UseQueryOptions<Partial<VoiceboxSettings> | null>
) => {
  const connection = usePortalConnectionByIndex(connectionIdx);
  const connectionId = connection.data?.id;
  return useQuery<Partial<VoiceboxSettings> | null>(
    `usePortalVoiceboxLastSettings-${connectionId ? connectionIdx : ''}`,
    async () => {
      if (!connectionId) {
        return null;
      }

      const sdk = getPortalSdk();
      if (!sdk) {
        throw new Error('!sdk');
      }

      const conversations = await sdk.listVoiceboxConversations();
      if (!conversations) {
        return {};
      }

      const firstMatchingConversation = conversations.conversations.find(
        (conversation) =>
          conversation.last_user_message &&
          conversation.last_user_message.user_message_context &&
          conversation.last_user_message.user_message_context.connection_id ===
            connectionId
      );

      const firstMessageContext =
        firstMatchingConversation?.last_user_message?.user_message_context;
      if (!firstMessageContext) {
        return {};
      }

      const settings: Partial<VoiceboxSettings> = {};
      if (typeof firstMessageContext.database === 'string') {
        settings.databaseId = firstMessageContext.database;
      }
      if (typeof firstMessageContext.model === 'string') {
        settings.model = firstMessageContext.model;
      }
      if (firstMessageContext.named_graphs) {
        settings.namedGraphs = firstMessageContext.named_graphs.filter(
          (graph): graph is string => Boolean(graph)
        );
      }
      if (typeof firstMessageContext.reasoning === 'boolean') {
        settings.reasoning = firstMessageContext.reasoning;
      }

      return settings;
    },
    options
  );
};
